import { httpClient } from "@utils";

export default class VersionChangeDetectorService {
	static async FetchLatestVersion(): Promise<{
		version: string;
		commitHash: string;
		branch: string;
	} | null> {
		try {
			return await httpClient.get("/version.json", undefined, {
				responseType: "json",
				cache: "no-store",
			});
		} catch (e) {
			console.log(e);
			return null;
		}
	}
}
